import { render, staticRenderFns } from "./m-dialog-sign-plugin-common.vue?vue&type=template&id=7f60c104&lang=pug&"
import script from "./m-dialog-sign-plugin-common.vue?vue&type=script&lang=js&"
export * from "./m-dialog-sign-plugin-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VOverlay,VRow})
